import { Panel } from "./Panel";

export const Filters = () => { }

Filters.Panel = Panel;